import { __awaiter, __decorate, __extends, __generator, __metadata } from "tslib";
import { AsyncDataSource } from './AsyncDataSource';
import NeoModel from '../Model/NeoModel';
import List from '../Model/List';
import AxiosUtils from "../AxiosUtils";
/**
 * Allows an api endpoint to be used directly by a consumer such as a drop down element.
 * If you need the data to be deserialised into a specific lookup model, use ApiClientLookupDataSource.
 */
var ApiClientDataSource = /** @class */ (function (_super) {
    __extends(ApiClientDataSource, _super);
    function ApiClientDataSource(getMethod, defaultData) {
        var _this = _super.call(this, defaultData !== null && defaultData !== void 0 ? defaultData : []) || this;
        _this.getMethod = getMethod;
        _this.defaultData = defaultData;
        return _this;
    }
    ApiClientDataSource.prototype.getDataAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMethod()];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    ApiClientDataSource = __decorate([
        NeoModel,
        __metadata("design:paramtypes", [Function, Object])
    ], ApiClientDataSource);
    return ApiClientDataSource;
}(AsyncDataSource));
export { ApiClientDataSource };
var ConvertingApiClientDataSource = /** @class */ (function (_super) {
    __extends(ConvertingApiClientDataSource, _super);
    function ConvertingApiClientDataSource(getMethod, defaultData, supportOffline) {
        var _this = _super.call(this, defaultData) || this;
        _this.getMethod = getMethod;
        _this.supportOffline = supportOffline;
        return _this;
    }
    ConvertingApiClientDataSource.prototype.getDataAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var rawData, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!navigator.onLine) return [3 /*break*/, 2];
                        return [4 /*yield*/, AxiosUtils.catchErrors(this.getMethod())];
                    case 1:
                        result = _a.sent();
                        if (result.success) {
                            rawData = result.data;
                            if (this.supportOffline) {
                                this.offlineStore(rawData);
                            }
                        }
                        else if (!result.isNetworkError || !this.supportOffline) {
                            throw result.error;
                        }
                        _a.label = 2;
                    case 2:
                        if (!this.supportOffline) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.offlineGet()];
                    case 3:
                        rawData = _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, this.convertData(rawData)];
                }
            });
        });
    };
    return ConvertingApiClientDataSource;
}(AsyncDataSource));
export { ConvertingApiClientDataSource };
/**
 * Allows an api endpoint to be used directly by a consumer such as a drop down element.
 * Deserialises the json data returned by the api into a list of the specified lookup object.
 */
var ApiClientLookupDataSource = /** @class */ (function (_super) {
    __extends(ApiClientLookupDataSource, _super);
    function ApiClientLookupDataSource(getMethod, deserialiseType, defaultData, dbSet) {
        var _this = _super.call(this, getMethod, defaultData !== null && defaultData !== void 0 ? defaultData : [], dbSet !== undefined) || this;
        _this.deserialiseType = deserialiseType;
        _this.dbSet = dbSet;
        return _this;
    }
    ApiClientLookupDataSource.prototype.offlineGet = function () {
        return this.dbSet.getAllAsync();
    };
    ApiClientLookupDataSource.prototype.offlineStore = function (rawData) {
        return this.dbSet.putAsync(rawData);
    };
    ApiClientLookupDataSource.prototype.convertData = function (rawData) {
        return List.fromJSArray(this.deserialiseType, rawData);
    };
    ApiClientLookupDataSource = __decorate([
        NeoModel,
        __metadata("design:paramtypes", [Function, Function, Array, Object])
    ], ApiClientLookupDataSource);
    return ApiClientLookupDataSource;
}(ConvertingApiClientDataSource));
export { ApiClientLookupDataSource };
var ApiClientSingleLookupDataSource = /** @class */ (function (_super) {
    __extends(ApiClientSingleLookupDataSource, _super);
    function ApiClientSingleLookupDataSource(getMethod, deserialiseType, defaultData, dbSet) {
        var _this = _super.call(this, getMethod, defaultData !== null && defaultData !== void 0 ? defaultData : new deserialiseType(), dbSet !== undefined) || this;
        _this.deserialiseType = deserialiseType;
        _this.dbSet = dbSet;
        return _this;
    }
    ApiClientSingleLookupDataSource.prototype.offlineGet = function () {
        return this.dbSet.getAsync(1);
    };
    ApiClientSingleLookupDataSource.prototype.offlineStore = function (rawData) {
        return this.dbSet.putAsync(rawData, 1);
    };
    ApiClientSingleLookupDataSource.prototype.convertData = function (rawData) {
        var model = new this.deserialiseType();
        model.set(rawData);
        return model;
    };
    ApiClientSingleLookupDataSource = __decorate([
        NeoModel,
        __metadata("design:paramtypes", [Function, Function, Object, Object])
    ], ApiClientSingleLookupDataSource);
    return ApiClientSingleLookupDataSource;
}(ConvertingApiClientDataSource));
export { ApiClientSingleLookupDataSource };
